import { useOutsideClick } from './useoutsideclick';
export default useOutsideClick;
